import { useState } from "react";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import Button from "../../components/base/Button";
import Card from "../../components/base/Card";
import Rendering18 from "@/assets/images/3D/1.png";
import Rendering17 from "@/assets/images/3D/2.jpg";
import Rendering16 from "@/assets/images/3D/3.jpg";
import Rendering15 from "@/assets/images/3D/4.jpg";
import Rendering5 from "@/assets/images/3D/5.jpg";
import Rendering6 from "@/assets/images/3D/6.png";
import Rendering1 from "@/assets/images/3D/7.png";
import Rendering8 from "@/assets/images/3D/8.png";
import Rendering9 from "@/assets/images/3D/9.png";
import Rendering10 from "@/assets/images/3D/10.png";
import Rendering11 from "@/assets/images/3D/11.png";
import Rendering12 from "@/assets/images/3D/12.png";
import Rendering13 from "@/assets/images/3D/13.png";
import Rendering7 from "@/assets/images/3D/3d15.png";
import Rendering2 from "@/assets/images/3D/3d16.png";
import Rendering3 from "@/assets/images/3D/3d17.png";
import Rendering4 from "@/assets/images/3D/3d18.png";
import FlooPlan1 from "@/assets/images/floorplan/1.png";
import FlooPlan2 from "@/assets/images/floorplan/2.png";
import FlooPlan3 from "@/assets/images/floorplan/3.png";
import FlooPlan4 from "@/assets/images/floorplan/4.png";
import FlooPlan5 from "@/assets/images/floorplan/5.png";
import FlooPlan6 from "@/assets/images/floorplan/6.png";
import FlooPlan7 from "@/assets/images/floorplan/7.png";
import FlooPlan8 from "@/assets/images/floorplan/8.png";
import FlooPlan9 from "@/assets/images/floorplan/9.png";
import FlooPlan10 from "@/assets/images/floorplan/10.png";
import Lighting1 from "@/assets/images/lighting/1.png";
import Lighting2 from "@/assets/images/lighting/2.png";
import Lighting3 from "@/assets/images/lighting/3.png";
import Lighting4 from "@/assets/images/lighting/4.png";
import Lighting5 from "@/assets/images/lighting/5.png";
import Lighting6 from "@/assets/images/lighting/6.png";
import Lighting7 from "@/assets/images/lighting/7.png";
import LineDiagram1 from "@/assets/images/linediagram/1.png";
import LineDiagram2 from "@/assets/images/linediagram/2.png";
import Wifi1 from "@/assets/images/wifi/1.png";
import Wifi2 from "@/assets/images/wifi/2.png";
import Wifi3 from "@/assets/images/wifi/3.png";

import Project1Image from "@/assets/images/1-1Remodel.png";
import Project2Image from "../../assets/images/2Landscape Lighting.png";
import HeroImage from "@/assets/images/portfolio_hero.jpg";
import PortfolioSectionA from "../home/components/PortfolioSectionA";

export default function PortfolioPage() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [selectedProject, setSelectedProject] = useState<number | null>(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const categories = [
    "All",
    "Lighting Design & Analysis",
    "Wifi-Lighting Design",
    "3D Visualization & Renderings",
    "Floor Plans",
    "Line Diagrams",
  ];

 const projects = [
  {
    id: 1,
    category: "3D Visualization & Renderings",
    image: Rendering7,
  },
  {
    id: 2,
    category: "Floor Plans",
    image: FlooPlan4,
  },
  {
    id: 3,
    category: "Lighting Design & Analysis",
    image: Lighting3,
  },
  {
    id: 4,
    category: "Wifi-Lighting Design",
    image: Wifi1,
  },
  {
    id: 5,
    category: "3D Visualization & Renderings",
    image: Rendering11,
  },
  {
    id: 6,
    category: "Line Diagrams",
    image: LineDiagram1,
  },
  {
    id: 7,
    category: "Floor Plans",
    image: FlooPlan2,
  },
  {
    id: 8,
    category: "Lighting Design & Analysis",
    image: Lighting6,
  },
  {
    id: 9,
    category: "Lighting Design & Analysis",
    image: Project1Image,
  },
  {
    id: 10,
    category: "3D Visualization & Renderings",
    image: Rendering3,
  },
  {
    id: 11,
    category: "Floor Plans",
    image: FlooPlan7,
  },
  {
    id: 12,
    category: "Lighting Design & Analysis",
    image: Lighting4,
  },
  {
    id: 13,
    category: "3D Visualization & Renderings",
    image: Rendering1,
  },
  {
    id: 14,
    category: "Floor Plans",
    image: FlooPlan5,
  },
  {
    id: 15,
    category: "Lighting Design & Analysis",
    image: Lighting5,
  },
  {
    id: 16,
    category: "Floor Plans",
    image: FlooPlan9,
  },
  {
    id: 17,
    category: "Wifi-Lighting Design",
    image: Wifi3,
  },
  {
    id: 18,
    category: "3D Visualization & Renderings",
    image: Rendering10,
  },
  {
    id: 19,
    category: "Lighting Design & Analysis",
    image: Project2Image,
  },
  {
    id: 20,
    category: "Floor Plans",
    image: FlooPlan6,
  },
  {
    id: 21,
    category: "Line Diagrams",
    image: LineDiagram2,
  },
  {
    id: 22,
    category: "3D Visualization & Renderings",
    image: Rendering5,
  },
  {
    id: 23,
    category: "Lighting Design & Analysis",
    image: Lighting1,
  },
  {
    id: 24,
    category: "3D Visualization & Renderings",
    image: Rendering12,
  },
  {
    id: 25,
    category: "Floor Plans",
    image: FlooPlan1,
  },
  {
    id: 26,
    category: "3D Visualization & Renderings",
    image: Rendering13,
  },
  {
    id: 27,
    category: "Lighting Design & Analysis",
    image: Lighting7,
  },
  {
    id: 28,
    category: "3D Visualization & Renderings",
    image: Rendering6,
  },
  {
    id: 29,
    category: "3D Visualization & Renderings",
    image: Rendering2,
  },
  {
    id: 30,
    category: "3D Visualization & Renderings",
    image: Rendering4,
  },
  {
    id: 31,
    category: "Floor Plans",
    image: FlooPlan10,
  },
  {
    id: 32,
    category: "Wifi-Lighting Design",
    image: Wifi2,
  },
  {
    id: 33,
    category: "Lighting Design & Analysis",
    image: Lighting2,
  },
  {
    id: 34,
    category: "3D Visualization & Renderings",
    image: Rendering9,
  },
  {
    id: 35,
    category: "3D Visualization & Renderings",
    image: Rendering8,
  },
  {
    id: 36,
    category: "Floor Plans",
    image: FlooPlan3,
  },
  {
    id: 37,
    category: "Floor Plans",
    image: FlooPlan8,
  },
  {
    id: 38,
    category: "3D Visualization & Renderings",
    image: Rendering11,
  },
  {
    id: 39,
    category: "3D Visualization & Renderings",
    image: Rendering15,
  },
  {
    id: 40,
    category: "3D Visualization & Renderings",
    image: Rendering16,
  },
  {
    id: 41,
    category: "3D Visualization & Renderings",
    image: Rendering17,
  },
   {
    id: 42,
    category: "3D Visualization & Renderings",
    image: Rendering18,
  },

];


  const featuredProjects = [
    {
      id: 1,
      title: "Modern Condo Interior Upgrade",
      category: "Lighting Design & Analysis",
      image: Project1Image,
    },
    {
      id: 2,
      title: "Landscape Lighting Layout",
      category: "Lighting Design & Analysis",
      image: Project2Image,
    },
  ];

  const filteredProjects =
    activeFilter === "All"
      ? projects
      : projects.filter((project) => project.category === activeFilter);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % featuredProjects.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + featuredProjects.length) % featuredProjects.length
    );
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative py-20 bg-gradient-to-br from-[#dbcfbf]/30 to-white dark:from-slate-800/50 dark:to-slate-900 transition-colors duration-300">
          <div
            className="absolute inset-0 opacity-15"
            style={{
              backgroundImage: `url('${HeroImage}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#212026] dark:text-gray-100 mb-6 transition-colors duration-300">
              Our Portfolio
            </h1>
            <p className="text-xl md:text-2xl text-[#889d8f] dark:text-gray-300 max-w-4xl mx-auto transition-colors duration-300">
              Explore our projects across AutoCAD, Revit, Dialux, Floor Plans,
              and Line Diagrams
            </p>
          </div>
        </section>

        {/* Filter Navigation */}
        <section className="py-8 bg-white dark:bg-slate-900 border-b border-[#dbcfbf]/30 dark:border-slate-700 transition-colors duration-300">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setActiveFilter(category)}
                  className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                    activeFilter === category
                      ? "bg-[#e18033] text-white shadow-lg"
                      : "bg-[#dbcfbf]/20 dark:bg-slate-700/50 text-[#212026] dark:text-gray-200 hover:bg-[#dbcfbf]/40 dark:hover:bg-slate-600/50"
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
            <div className="text-center mt-4">
              <p className="text-[#889d8f] dark:text-gray-300 transition-colors duration-300">
                Showing {filteredProjects.length} image
                {filteredProjects.length !== 1 ? "s" : ""}
              </p>
            </div>
          </div>
        </section>

        {/* Portfolio Grid Section */}
        <section className="py-20 bg-white dark:bg-slate-900 transition-colors duration-300">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {filteredProjects.map((project) => (
                <Card
                  key={project.id}
                  className="group overflow-hidden cursor-pointer bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300"
                  onClick={() =>
                    setSelectedProject(
                      selectedProject === project.id ? null : project.id
                    )
                  }
                >
                  <div className="relative h-64 bg-[#dbcfbf]/10 dark:bg-slate-700/30">
                    <img
                      src={project.image}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#212026]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="text-center text-white">
                        <div className="w-12 h-12 bg-[#e18033] rounded-full flex items-center justify-center mx-auto mb-2">
                          <div className="w-6 h-6 flex items-center justify-center">
                            <i className="ri-eye-line text-xl"></i>
                          </div>
                        </div>
                        <p className="text-sm font-medium">View Project</p>
                      </div>
                    </div>
                    <div className="absolute top-4 left-4 px-3 py-1 bg-[#e18033] text-white text-xs font-medium rounded-full">
                      {project.category}
                    </div>
                  </div>
                  {/* Project Detail Modal */}
                  {selectedProject === project.id && (
                    <div className="fixed inset-0 bg-[#212026]/80 dark:bg-black/90 flex items-center justify-center z-50 p-4 transition-colors duration-300">
                      <div className="bg-white dark:bg-slate-800 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-auto transition-colors duration-300">
                        <div className="relative">
                          <img
                            src={project.image}
                            className="w-full h-full object-cover object-top"
                          />
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedProject(null);
                            }}
                            className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-[#e18033]/30 rounded-full flex items-center justify-center cursor-pointer transition-colors duration-300"
                          >
                            <div className="w-6 h-6 flex items-center justify-center">
                              <i className="ri-close-line text-white text-xl"></i>
                            </div>
                          </button>
                          <div className="absolute top-4 left-4 px-3 py-1 bg-[#e18033] text-white text-sm font-medium rounded-full">
                            {project.category}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Projects Section */}
         <PortfolioSectionA/>
        {/* Call-to-Action Section */}
        <section className="py-20 bg-[#e18033] dark:bg-[#d16f29] transition-colors duration-300">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Want similar results for your project?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Let our expert team deliver the same level of precision and
              quality for your next engineering or design project
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
               <a href='/contact'>
                           <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-black dark:border-gray-300 dark:hover:bg-gray-300 dark:hover:text-slate-900 transition-all duration-300">
                             <div className="w-5 h-5 flex items-center justify-center mr-2">
                               <i className="ri-phone-line"></i>
                             </div>
                             Contact Us
                           </Button></a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
